import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'lib-app-transaction-import-toolbar',
  templateUrl: './transaction-import-toolbar.component.html',
  styleUrls: ['./transaction-import-toolbar.component.scss'],
})
export class TransactionImportToolbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
